import { useState } from "react";

const useActive = (initialValue, onChange) => {
  const [active, setActive] = useState(initialValue);

  const handleActive = (active) => {
    if (typeof active === "function") {
      setActive((prevValue) => {
        const value = active(prevValue);
        onChange && onChange(value);
        return value;
      });
    } else {
      setActive(active);
      onChange && onChange(active);
    }
  };

  return {
    active,
    handleActive,
  };
};

export default useActive;
